export default {
    fullSizeEditorMinWidth: 1300,
    referenceWidth: 600
};
